define(function() {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const ordinalNumberSuffixes = ['th', 'st', 'nd', 'rd'];

  return {
    snakeCase: function snakeCase(str) {
      return (
        str[0].toLowerCase() +
        str.slice(1).replace(/([A-Z|0-9]+)/g, function snakeReplace(m, x) {
          return '_' + x.toLowerCase();
        })
      ).replace(/(\s+)/g, '');
    },
    camelCase: function camelCase(name) {
      if (uuidRegex.test(name)) return name;
      // eslint-disable-next-line no-useless-escape
      var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
      return name.replace(SPECIAL_CHARS_REGEXP, function(
        _,
        separator,
        letter,
        offset
      ) {
        return offset ? letter.toUpperCase() : letter;
      });
    },
    partition: function partition(arr, payload) {
      return arr.reduce(
        function(acc, curr) {
          var match = Object.keys(payload).every(function(key) {
            return curr[key] === payload[key];
          });
          if (match) {
            acc[0].push(curr);
          } else {
            acc[1].push(curr);
          }
          return acc;
        },
        [[], []]
      );
    },
    prettyPrintNumber: function prettyPrintNumber(
      number,
      thousandsDelimiter = ',',
      decimalDelimiter = '.'
    ) {
      var str = String(number);
      var leftPart = str.split('.')[0];
      var rightPart = str.split('.')[1];
      var newLeftPart = '';
      for (var i = 0, ci, d; i < leftPart.length; i++) {
        ci = leftPart.length - i - 1;
        d = leftPart[ci];
        newLeftPart = d + newLeftPart;
        if ((i + 1) % 3 === 0 && ci > 0) {
          newLeftPart = thousandsDelimiter + newLeftPart;
        }
      }
      var formattedNum = newLeftPart;
      if (rightPart) formattedNum += decimalDelimiter + str.split('.')[1];
      return formattedNum;
    },
    getOrdinalNumber: function getOrdinalNumber(number) {
      number = Math.floor(number);
      var suffix;
      var formattedNum = this.prettyPrintNumber(number);
      var lastDigit = Number(formattedNum.charAt(formattedNum.length - 1));
      if (number >= 10 && number < 20) suffix = 'th';
      else suffix = ordinalNumberSuffixes[lastDigit] || 'th';
      return formattedNum + suffix;
    }
  };
});
